<template>
  <v-card flat class="pb-4">
    <v-card-title class="text-h6 pa-3">
      Edit Web Categories
    </v-card-title>

    <v-row class="" justify="space-between">
      <!-- Tree View -->
      <v-col cols="12" style="flex-basis: 350px">
        <v-treeview
          :active="active"
          :items="items"
          :load-children="fetchRoute"
          :open.sync="open"
          item-text="title"
          item-children="subTypes"
          item-key="_id"
          item-disabled="disabled"
          color=""
          transition
          dense
        >
          <!-- Acction Button -->
          <template v-slot:append="{ item }">
            <template v-if="!item.disabled">
              <v-btn
                v-if="
                  ['animals', 'petfoods', 'supplies'].indexOf(item.path) == -1
                "
                icon
                small
                color="primary"
                @click="editRoute(item)"
                ><v-icon small>mdi-pencil</v-icon></v-btn
              >
              <v-btn
                v-if="item.layer != MAX_ROUTE_DEPTH"
                icon
                small
                color="primary"
                @click="addRouteTo(item)"
                ><v-icon small>add</v-icon></v-btn
              >
            </template>
          </template>
        </v-treeview>
      </v-col>

      <v-divider vertical></v-divider>

      <!-- Editer/Right Panel -->
      <v-col class="d-flex justify-center text-center align-start">
        <v-scroll-y-transition mode="out-in">
          <!-- When nothing selected -->
          <div
            v-if="!edit._id"
            class="text-h6 grey--text font-weight-light pt-4"
            style="position: sticky; top: 20%"
          >
            Select a category
          </div>

          <!-- Edit Field -->
          <v-card
            v-else
            :key="edit._id"
            flat
            max-width="500"
            min-width="300"
            class="mx-auto"
            style="position: sticky; top: 20%"
          >
            <!-- Edit Header -->
            <v-card-text>
              <div class="text-subtitle-1 font-weight-medium mb-1">
                {{
                  edit.parent
                    ? `Add to ${edit.parent.title}`
                    : `ID: ${edit._id}`
                }}
              </div>
              <div v-if="edit.parent" class="text-caption">
                Parent : {{ edit.parent._id }}
              </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-form ref="form">
              <!-- Title Text Field -->
              <v-text-field
                label="Title"
                v-model="edit.title"
                class="mt-4"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>

              <!-- Path Text Field -->
              <v-text-field
                label="Path"
                v-model="edit.path"
                :rules="[(v) => !!v || 'required']"
                hint="Auto generated, accourding to title"
                persistent-hint
              ></v-text-field>

              <!-- Thai Title Text Field -->
              <v-text-field
                label="ชื่อภาษาไทย (Optional)"
                class="mt-2"
                v-model="edit.titleTh"
              ></v-text-field>
            </v-form>

            <!-- Action Button -->
            <v-row class="mt-2" no-gutters>
              <v-spacer></v-spacer>
              <!-- Edit Route Button -->
              <template v-if="!edit.parent">
                <v-btn
                  small
                  depressed
                  class="rounded-xl darken-2"
                  color="red"
                  :dark="!edit.subTypes"
                  :disabled="!!edit.subTypes"
                  @click="deleteRoute"
                  >Delete</v-btn
                >

                <v-btn
                  small
                  depressed
                  class="rounded-xl cyan lighten-1 ml-3"
                  :dark="!pathNoChange"
                  :disabled="pathNoChange"
                  @click="updateRoute"
                  >Save</v-btn
                >
              </template>

              <!-- Add Route Button -->
              <template v-else>
                <v-btn
                  small
                  depressed
                  class="rounded-xl secondary lighten-4"
                  dark
                  @click="edit = {}"
                  >Cancel</v-btn
                >
                <v-btn
                  small
                  depressed
                  class="rounded-xl cyan lighten-1 ml-3"
                  dark
                  @click="addRoute"
                  >Add</v-btn
                >
              </template>
            </v-row>
          </v-card>
        </v-scroll-y-transition>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import admin from "../../services/admin";
import api from "../../services/api";

export default {
  data: () => ({
    MAX_ROUTE_DEPTH: 4,
    loading: true,
    active: [],
    open: [0],
    openBefore: [],
    edit: {},
    items: [{ _id: 0, title: "Loading", disabled: true, subTypes: [] }],
  }),
  mounted() {},
  methods: {
    editRoute(item) {
      this.active = [item._id];
      if (item._id) {
        item.oTitle = item.title;
        item.oPath = item.path;
        item.oTitleTh = item.titleTh || "";
        item.titleTh = item.titleTh || "";
        this.edit = { ...item };
      }
    },
    addRouteTo(item) {
      this.active = [item._id];
      this.edit = { _id: `${item._id}e`, parent: item };
    },
    findRoute(items, _id) {
      for (let item of items) {
        if (item._id == _id) return item;
        if (item.subTypes.length) {
          const res = this.findRoute(item.subTypes, _id);
          if (res) return res;
        }
      }
    },
    addRouteLayer(items, layer = 0) {
      items.forEach((item) => {
        item.layer = layer;
        if (item.subTypes) {
          this.addRouteLayer(item.subTypes, layer+1);
        }
      });
    },
    // API FUNCTION (BELOW)
    async fetchRoute(_item) {
      this.items = await admin.getRawRoute();
      this.addRouteLayer(this.items);
      if (this.openBefore.length) {
        this.open = this.openBefore;
        const _tmp = this.active;
        this.active = [];
        await new Promise((r) => setTimeout(r, 100));
        this.active = _tmp;
      }
    },
    async updateRoute() {
      let { _id, title, path, titleTh } = this.edit;
      if (!this.$refs.form.validate()) return;
      let data = { _id, title, path, titleTh };

      // Update route
      console.log("Update ", data);
      const { msg, success } = await admin.updateRoute(data);
      if (!success) return api.makeAlert(msg, "error");
      api.makeAlert("Update Category Successfully", "success");
      this.reloadRoute();
    },
    async addRoute() {
      let { parent, title, path, titleTh } = this.edit;
      if (!this.$refs.form.validate()) return;
      if (!parent || !title || !path || parent.layer >= this.MAX_ROUTE_DEPTH) return;
      let data = { parent: parent._id, title, path, titleTh };

      console.log("Add ", data);
      const { msg, success } = await admin.addRoute(data);
      if (!success) return api.makeAlert(msg, "error");
      api.makeAlert("Add Category Successfully", "success");
      this.reloadRoute();
    },
    async deleteRoute() {
      let { _id, title } = this.edit;
      if (!_id) return;
      if (!confirm(`Confirm to delete this route?\n=> ${title}`)) return;

      console.log("Delete", _id);
      const { msg, success } = await admin.deleteRoute(_id);
      if (!success) return api.makeAlert(msg, "error");
      api.makeAlert("Delete Category Successfully", "success");
      this.reloadRoute();
    },
    async reloadRoute() {
      this.edit = {}; // Hide editer panel
      this.openBefore = this.open;
      this.items = [{ _id: 0, title: "Loading", disabled: true, subTypes: [] }];
      await new Promise((r) => setTimeout(r, 10));
      this.open = [0];
    },
  },
  computed: {
    pathNoChange() {
      let edit = this.edit;
      return edit.oTitle == edit.title && edit.oTitleTh == edit.titleTh && edit.oPath == edit.path;
    }
  },
  watch: {
    'edit.title': function(title) {
      if (!title) return;
      if(this.pathNoChange) return;
      let path = title.toLowerCase();
      path = path.replace(/\%\s/g, "-");
      path = path.replace(/[\s|\)|\%]/g, "");
      path = path.replace(/[\/|\\|\(|\+|\&]/g, "-");
      this.edit.path = path;
    }
  }
};
</script>

<style>
</style>